import axios from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";
//SITE


export const getOrg = (id) => {
  

  return axiosInstance
    .get(`/organization/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};





export const CreateSite = (body) => {

  body.organization = { id: 1 };
  return axiosInstance
    .post(`/createNewSite`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};


export const CreateBudget = (body) => {

  return axiosInstance
    .post(`/budget/createNewBudgetForAsset/${body.id}`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};


export const UpdateSite = (body) => {
  

  // body.organization = { id: 1 };
  return axiosInstance
    .put(`/site/${body.id}`, body)
    .then((response) => {
      
      
      return response.data.response[0];
    })
    .catch((error) => {
       var response = catchAxiosError(error);
       return response;
    });
};

export const DeleteSite = (id) => {

  return axiosInstance
    .delete(`/site/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getSite = (id) => {
  

  return axiosInstance
    .get(`/site/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getSites = () => {
  

  return axiosInstance
    .get(`/getAllSites`)
    .then((response) => {
      
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};



export const getBudgets = () => {
  return axiosInstance
    .get(`/budget/getSumBudgetsOfAssetsGroupBySite/1`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getSiteBudgets = (siteId) => {
  return axiosInstance
    .get(`/budget/getBudgetsInfoGroupByAssetBySiteId/${siteId}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};


//BUILDING

export const CreateBuilding = (body) => {
  

  return axiosInstance
    .post(`/createNewBuilding`, body)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const UpdateBuilding = (body) => {
  

  // body.organization = { id: 1 };
  return axiosInstance
    .put(`/building/${body.id}`, body)
    .then((response) => {
      
      
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
      return response;
    });
};

export const getBuilding = (id) => {
  

  return axiosInstance
    .get(`/building/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const deleteBuilding = (id) => {

  return axiosInstance
    .delete(`/building/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllBuildings = () => {
  

  return axiosInstance
    .get(`/getAllBuildings`)
    .then((response) => {
      
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

//ASSET

export const CreateAsset = (body) => {
  

  return axiosInstance
    .post(`/createNewAsset`, body)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const UpdateAsset = (body) => {
  

  // body.organization = { id: 1 };
  return axiosInstance
    .put(`/asset/${body.id}`, body)
    .then((response) => {
      
      
      return response.data.response[0];
    })
    .catch((error) => {
       var response = catchAxiosError(error);
       return response;
    });
};

export const deleteAsset = (id) => {

  return axiosInstance
    .delete(`/asset/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};



export const AssociateAsset = (body) => {
  

  return axiosInstance
    .put(
      `/asset/associateOneAssetToManyBuildings/${body.id}`,
      body.buildings)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const dissociateAsset = (body) => {
  

  return axiosInstance
    .put(
      `/asset/dissociateOneAssetFromManyBuildings/${body.id}`,
      body.buildings)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAsset = (id) => {
  

  return axiosInstance
    .get(`/asset/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllAssets = () => {
  

  return axiosInstance
    .get(`/getAllAssets`)
    .then((response) => {
      
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};
export const filterAssets = (data) => {
  return axiosInstance
    .post(`/asset/getDataExplorerForAssetsByCriteria`, data)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};
//private methods

export const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
  
    const message = error.message;
    return { errors:[message]}
  }
};
